import useTracking from "../../common/tracking/ninja/useTracking";
import useTranslation from "../../common/translations";
import { useSearchOrchestration } from "../hooks/useSearchOrchestration";
import SearchResults from "./SearchResults";
import React, { useEffect, useRef, useState } from "react";
export default function DesktopSearchWrapper() {
    const { t } = useTranslation("site-search");
    const { trackEvent } = useTracking();
    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const containerRef = useRef(null);
    const inputRef = useRef(null);
    const debounceRef = useRef(null);
    const hasTrackedStartRef = useRef(false);
    const pendingNavigateRef = useRef(false);
    const { query, setQuery, trackTypingOnce, loading, error, groups, noResultSuggestions, isTypoFallback, recent, handleClearRecent, handleSelectSuggestion, handleSelectRecentItem, } = useSearchOrchestration({ onSelect: () => setOpen(false) });
    useEffect(() => {
        var _a, _b;
        if (!pendingNavigateRef.current || loading || error)
            return;
        pendingNavigateRef.current = false;
        const firstItem = (_b = (_a = groups.find((g) => g.items.length > 0)) === null || _a === void 0 ? void 0 : _a.items[0]) !== null && _b !== void 0 ? _b : noResultSuggestions[0];
        if (firstItem)
            handleSelectSuggestion(firstItem);
    }, [groups, loading, error]);
    useEffect(() => {
        if (!open)
            return;
        function handleClickOutside(e) {
            if (containerRef.current &&
                !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        }
        function handleKeyDown(e) {
            var _a;
            if (e.key === "Escape") {
                setOpen(false);
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [open]);
    function handleFocus() {
        if (!hasTrackedStartRef.current) {
            hasTrackedStartRef.current = true;
            trackEvent("search_text_start");
        }
        setOpen(true);
    }
    function handleChange(e) {
        const value = e.target.value;
        setInputValue(value);
        trackTypingOnce(value);
        setOpen(true);
        if (debounceRef.current !== null)
            window.clearTimeout(debounceRef.current);
        debounceRef.current = window.setTimeout(() => {
            debounceRef.current = null;
            setQuery(value);
        }, 500);
    }
    function handleSubmit(e) {
        var _a, _b;
        e.preventDefault();
        if (debounceRef.current !== null) {
            window.clearTimeout(debounceRef.current);
            debounceRef.current = null;
            if (inputValue !== query) {
                setQuery(inputValue);
                pendingNavigateRef.current = true;
                return;
            }
        }
        if (loading || error)
            return;
        const firstItem = (_b = (_a = groups.find((g) => g.items.length > 0)) === null || _a === void 0 ? void 0 : _a.items[0]) !== null && _b !== void 0 ? _b : noResultSuggestions[0];
        if (firstItem) {
            handleSelectSuggestion(firstItem);
        }
    }
    const showDropdown = open && (query.length > 0 || recent.length > 0);
    return (<div ref={containerRef} className="search relative">
      <form className="mb-0" onSubmit={handleSubmit}>
        <div className="flex items-center border border-transparent bg-[#EBECEF] rounded-[2.5rem] h-[5rem] px-[2rem] pl-[3rem]">
          <div className="w-full h-full flex">
            <input ref={inputRef} type="text" name="q" value={inputValue} placeholder={t("search.header.placeholder")} autoComplete="off" className="bg-transparent border-none outline-none text-[#020309] text-[1.6rem] w-full h-full placeholder:text-[#020309] focus:ring-0" onFocus={handleFocus} onChange={handleChange}/>
          </div>
          <div>
            <button type="submit" aria-label="Szukaj ofert" className="flex items-center bg-transparent border-none text-[2rem] text-[#0071CE] outline-none p-0 ml-[2rem]">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" className="text-[#020309]"><path d="M11.333,3A8.333,8.333,0,1,0,16.6,17.78l4.976,4.976a.833.833,0,1,0,1.179-1.179L17.78,16.6A8.325,8.325,0,0,0,11.333,3Zm0,1.667a6.667,6.667,0,1,1-6.667,6.667A6.654,6.654,0,0,1,11.333,4.667Z" transform="translate(-3 -3)"/></svg>
            </button>
          </div>
        </div>
      </form>

      {showDropdown && (<div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-[#EBECEF] max-h-[min(500px,calc(100vh-120px))] overflow-y-auto z-[600]">
          <div className="p-4">
            <SearchResults query={query} loading={loading} error={error} groups={groups} noResultSuggestions={noResultSuggestions} isTypoFallback={isTypoFallback} recent={recent} onClearRecent={handleClearRecent} onSelectRecentItem={handleSelectRecentItem} onSelectSuggestion={handleSelectSuggestion}/>
          </div>
        </div>)}
    </div>);
}
